"use client";

import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";
import { generateAIEventTitle } from "@/lib/generateAIEventTitle";

interface GenerateAiTitleButtonProps {
  startTime: Date;
  endTime: Date;
  onTitleGenerated: (title: string) => void;
}

export function GenerateAiTitleButton({
  startTime,
  endTime,
  onTitleGenerated,
}: GenerateAiTitleButtonProps) {
  const [isLoading, setIsLoading] = useState(false);

  const handleGenerateTitle = async () => {
    try {
      setIsLoading(true);
      const title = await generateAIEventTitle(
        `
        The time of the booking is ${startTime.toLocaleTimeString("sv-SE", {
          hour: "2-digit",
          minute: "2-digit",
        })} to ${endTime.toLocaleTimeString("sv-SE", {
          hour: "2-digit",
          minute: "2-digit",
        })}.
        `,
      );
      onTitleGenerated(title);
    } catch (e) {
      toast.error("Failed to generate title");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Button type="button" className="w-16" onClick={handleGenerateTitle} disabled={isLoading}>
      {isLoading ? <Loader2 className="animate-spin" /> : "✨"}
    </Button>
  );
}
